module.exports = __webpack_public_path__ + "img/ratehawk.7c02a5c1.png";